import { useState } from 'react';
import { BannerContainer, BannerContent } from './styles';
import { BitButton } from '../BitButton';
import { ArrowSquareOut } from '@phosphor-icons/react';
import { Spinner } from '@fluentui/react';
import { IBanner } from '../BannerCarousel';
import { useAppInsightsContext } from '@microsoft/applicationinsights-react-js';

interface BannerProps {
  data?: IBanner;
  onPause: () => void | undefined;
  onPlay: () => void | undefined;
}

export const Banner = ({ data, onPause, onPlay }: BannerProps) => {
  const appInsights = useAppInsightsContext();

  const [isIframeLoaded, setIsIframeLoaded] = useState(false);

  return (
    <BannerContainer backgroundImage={data?.backgroundImage ?? ''}>
      <BannerContent>
        {data ? (
          <>
            <h1>{data.headerText}</h1>
            <p>{data.bodyText}</p>

            <BitButton
              label={data.buttonText}
              icon={<ArrowSquareOut />}
              action={() => {
                window.open(data.buttonLink);
                if (process.env.REACT_APP_APP_INSIGHTS !== '')
                  appInsights.trackEvent({ name: 'Banner Button Clicked' });
              }}
            />

            <div className="videoContainer">
              {data.sideImage && (
                <div
                  className={`${isIframeLoaded ? 'loaded ' : ''} iframeWrapper`}
                >
                  <img
                    src="https://app.bitfractal.com/embedded/maxresdefault.jpg"
                    className="thumbnail"
                    alt=""
                  />
                  <iframe
                    title="BitFractal Readiness Video"
                    src={data.sideImage}
                    allow={'autoplay'}
                    allowFullScreen
                    height={168}
                    width={300}
                    onLoad={() => setIsIframeLoaded(true)}
                    onPlayCapture={() => onPlay()}
                    onPauseCapture={() => onPause()}
                  />
                </div>
              )}
            </div>
          </>
        ) : (
          <div className="loadingWrapper">
            <Spinner size={3} />
          </div>
        )}
      </BannerContent>
    </BannerContainer>
  );
};
